// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixLocation from 'wix-location';
import wixData from 'wix-data';

$w.onReady(async function () {
	let id = (await $w('#productPage1').getProduct())._id;
	loadRelatedItems(id);
});

async function loadRelatedItems (product) {
	let all = await Promise.all([
		wixData.query('RelatedItems')
		.eq('product1', product)
		.include('product2')
		.find(),
		wixData.query('RelatedItems')
		.eq('product2', product)
		.include('product1')
		.find()
	]);
	console.log(all);
	let data = [];
	for (let p of all[0].items) {
		data.push(p.product2);
	}
	for (let p of all[1].items) {
		data.push(p.product1);
	}
	if (data.length > 0) {
		console.log(data);
		$w('#repeater1').expand();
		$w('#repeater1').data = data;
	}
}

export function repeater1_itemReady($item, itemData, index) {
	console.log(itemData);
	$item('#productImage').src = itemData.mainMedia;
	$item('#productName').text = itemData.name;
	$item('#productImage').link = itemData.productPageUrl;
	$item('#moreInfo').onClick(async ()=>{
		await loadRelatedItems(itemData._id);
		wixLocation.to(itemData.productPageUrl);
	});
}